import axios from 'axios';
import {useEffect, useState} from 'react';

export function useWorldTime() {
  const [time, setTime] = useState<number>(Date.now());

  useEffect(() => {
    (async () => {
      try {
        const {data} = await axios.get(
          'https://worldtimeapi.org/api/timezone/America/Los_Angeles',
          {
            timeout: 5000,
          },
        );
        setTime(data.unixtime * 1000);
      } catch (err) {
        setTime(Date.now());
      }
    })();
  }, []);

  return time;
}
